import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import FileAudioRegular from './file-audio-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FileAudioRegular {...validProps} />;
}

SvgComponent.iconName = 'fileAudioRegular';

export const FileAudioRegularIcon = svgIconWrapper(SvgComponent);
